import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'sg-choose-avatar',
  templateUrl: './choose-avatar.component.html',
  styleUrls: ['./choose-avatar.component.scss']
})
export class ChooseAvatarComponent {

  @Output() chooseAvatarChange = new EventEmitter();

  closePopover(){
    this.chooseAvatarChange.emit(null);
  }

}
